/*
 * BOS in-house "Subscribe & Save" widget, replaces Stay's injected buy-box control.
 *
 * Reads our own app-owned selling-plan groups from the product JSON and, for the
 * CURRENTLY SELECTED variant, shows that variant's real subscription discount from
 * Shopify's own allocation (singles 20%, multipacks 8%, multipacks are already
 * bulk-discounted). Renders a One-Time / Subscribe toggle + frequency picker and sets
 * a hidden `selling_plan` input on the product form; the theme's own <product-form>
 * submits via FormData(form) to /cart/add, no permalink bug.
 *
 * NOTE: product-JSON allocations expose `selling_plan_id` + `per_delivery_price` only
 * (no nested plan object, that's cart.js). The plan NAME comes from the group.
 *
 * Robustness: strips any foreign (Stay) selling_plan input and re-syncs ours from the
 * picker state right before every submit; re-reads allocations on every variant change.
 */
(function () {
  if (window.__bosSubLoaded) return;
  window.__bosSubLoaded = true;

  var GROUP_RE = /^Subscribe & Save/;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  function money(cents) { return "$" + (cents / 100).toFixed(2); }
  function moneyShort(cents) { return "$" + (cents / 100).toFixed(2).replace(/\.00$/, ""); }
  // Per-serving line inside the Subscribe box (gonza 2026-08-10). Alma: 28g cup,
  // 16 cups/lb. Gmood: 30 capsules/pack. Kanna: 44 mL bottle, 1 mL serving (added 2026-08-28 per cacao funnel principles).
  var PERCUP = {
    "alma-cacao": { unit: "a cup", extra: "Under $1.50 a cup as daily hot chocolate", count: function (v) {
      var t = (v.title || "").toLowerCase();
      if (t.indexOf("\u00bd") > -1 || t.indexOf("1/2") > -1) return 9;
      var m = t.match(/(\d+)\s*lb/); return m ? parseInt(m[1], 10) * 18 : 18;
    } },
    "kanna": { unit: "a serving", extra: "Less than a latte for hours of calm", count: function (v) {
      var m = (v.title || "").match(/(\d+)\s*pack/i); return (m ? parseInt(m[1], 10) : 1) * 44;
    } },
    "gmood": { unit: "a day", count: function (v) {
      var m = (v.title || "").match(/(\d+)\s*pack/i); return (m ? parseInt(m[1], 10) : 1) * 20;
    } }
  };
  function cadence(name) {
    var l = (name || "").replace(/^every\s*/i, "");
    return l.charAt(0).toUpperCase() + l.slice(1);
  }
  function stripForeignPlanInputs(form) {
    var inputs = form.querySelectorAll('input[name="selling_plan"]');
    for (var i = 0; i < inputs.length; i++) {
      if (!inputs[i].hasAttribute("data-bos-selling-plan") && inputs[i].parentNode) {
        inputs[i].parentNode.removeChild(inputs[i]);
      }
    }
  }

  ready(function () {
    var handle = (window.MinimogSettings && window.MinimogSettings.productHandle) || null;
    if (!handle) {
      var pi = document.querySelector("product-info[data-product-handle]");
      handle = pi && pi.getAttribute("data-product-handle");
    }
    if (!handle) return;
    fetch("/products/" + handle + ".js").then(function (r) { return r.json(); }).then(init).catch(function () {});
  });

  function init(product) {
    var groups = (product.selling_plan_groups || []).filter(function (g) {
      return !g.app_id && GROUP_RE.test(g.name || "");
    });
    // plan id -> plan object (for names). Also our membership set.
    var plans = {};
    groups.forEach(function (g) { (g.selling_plans || []).forEach(function (p) { plans[p.id] = p; }); });
    if (!Object.keys(plans).length) return;

    var form = document.querySelector("product-form.m-product-form--main form")
      || document.querySelector("product-form form")
      || document.querySelector('form[action*="/cart/add"]');
    if (!form || form.querySelector("[data-bos-sub]")) return;

    injectStyles();
    // PDP serif = Lora (gonza 2026-08-12, PDP-only for cohesiveness)
    if (!document.getElementById("bos-lora")) {
      var pc = document.createElement("link"); pc.rel = "preconnect"; pc.href = "https://fonts.gstatic.com"; pc.crossOrigin = "";
      var lf = document.createElement("link"); lf.id = "bos-lora"; lf.rel = "stylesheet";
      lf.href = "https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;1,400&display=swap";
      document.head.appendChild(pc); document.head.appendChild(lf);
    }
    hideStay();
    stripForeignPlanInputs(form);

    var wrap = document.createElement("div");
    wrap.className = "bos-sub";
    wrap.setAttribute("data-bos-sub", "");
    var stripIcons = {
      "Zero Sugar": '<rect x="7.5" y="7.5" width="9" height="9" rx="1.5"/><path d="M4.5 19.5 19.5 4.5"/>',
      "Vegan": '<path d="M12 20.5C6.5 16 5.5 9.5 12 4c6.5 5.5 5.5 12 0 16.5Z"/><path d="M12 20.5V11"/>',
      "100% Pure Cacao": '<ellipse cx="12" cy="12" rx="5.5" ry="8.5"/><path d="M12 3.5v17"/><path d="M9 5.5c-1.5 4-1.5 9 0 13M15 5.5c1.5 4 1.5 9 0 13"/>'
    };
    var STRIP_ICONS_BY_HANDLE = {
      "kanna": ["18% Alkaloid Extract", "South African Botanical", "Lab-Tested Every Lot"],
      "gmood": ["Plant-Powered", "No Crash", "Small Batches"]
    };
    stripIcons["Plant-Based"] = stripIcons["Vegan"];
    stripIcons["Plant-Powered"] = stripIcons["Vegan"];
    stripIcons["South African Botanical"] = '<path d="M12 21s-6-5.2-6-10a6 6 0 1 1 12 0c0 4.8-6 10-6 10Z"/><circle cx="12" cy="11" r="2.2"/>';
    stripIcons["Small Batches"] = '<ellipse cx="8.5" cy="10" rx="2.6" ry="3.6" transform="rotate(-18 8.5 10)"/><ellipse cx="15.5" cy="10" rx="2.6" ry="3.6" transform="rotate(18 15.5 10)"/><ellipse cx="12" cy="16" rx="2.6" ry="3.6"/>';
    stripIcons["18% Alkaloid Extract"] = '<path d="M10 3h4M11 3v5.5L6.5 17a3 3 0 0 0 2.7 4.4h5.6A3 3 0 0 0 17.5 17L13 8.5V3"/><path d="M8.2 14.5h7.6"/>';
    stripIcons["Lab-Tested Every Lot"] = '<path d="M12 3l7 3v5.2c0 4.4-3 7.4-7 8.8-4-1.4-7-4.4-7-8.8V6l7-3Z"/><path d="m8.8 12 2.2 2.2 4.2-4.4"/>';
    stripIcons["No Crash"] = '<circle cx="12" cy="12" r="4"/><path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8"/>';
    var stripLabels = STRIP_ICONS_BY_HANDLE[product.handle || ""] || ["Zero Sugar", "Vegan", "100% Pure Cacao"];
    var stripHtml = stripLabels.map(function (t) {
      return '<span class="bos-strip__item"><svg viewBox="0 0 24 24" fill="none" stroke="#B8905A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + stripIcons[t] + "</svg>" + t + "</span>";
    }).join('<span class="bos-strip__dash">\u2014</span>');

    wrap.innerHTML =
      '<div class="bos-strip">' + stripHtml + "</div>"
      + '<div class="bos-sub__opts">'
      + '<label class="bos-sub__opt is-active" data-bos-optone>'
      +   '<span class="bos-sub__radio"><input type="radio" name="bos-ptype" value="onetime" checked></span>'
      +   '<span class="bos-sub__body"><span class="bos-sub__title">One-time purchase</span>'
      +     '<span class="bos-sub__price" data-bos-onetime></span></span>'
      + '</label>'
      + '<label class="bos-sub__opt bos-sub__opt--sub" data-bos-optsub>'
      +   '<span class="bos-sub__badge">Most popular</span>'
      +   '<span class="bos-sub__radio"><input type="radio" name="bos-ptype" value="subscribe"></span>'
      +   '<span class="bos-sub__body"><span class="bos-sub__title" data-bos-title>Subscribe &amp; Save</span>'
      +     '<span class="bos-sub__price"><span data-bos-subprice></span> '
      +     '<span class="bos-sub__was" data-bos-was></span></span>'
      +     '<span class="bos-sub__perks" data-bos-percup></span></span>'
      + '</label>'
      + '</div>'
      + '<div class="bos-sub__freq" data-bos-freq hidden>'
      +   '<label class="bos-sub__freq-label">Deliver every</label>'
      +   '<select class="bos-sub__freq-select" data-bos-plan></select>'
      +   '<p class="bos-sub__note" data-bos-note></p>'
      + '</div>';

    var atc = form.querySelector('[id^="ProductSubmitButton-"]');
    var anchor = atc ? (atc.closest(".m-product-form--wrapper") || atc) : null;
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor);
    else form.appendChild(wrap);

    var sp = document.createElement("input");
    sp.type = "hidden"; sp.name = "selling_plan"; sp.value = ""; sp.disabled = true;
    sp.setAttribute("data-bos-selling-plan", "");
    form.appendChild(sp);

    wire(wrap, sp, form, product, plans);

    // Quantity-card badges: show $ saved instead of % (vs compare-at)
    function dollarBadges() {
      var nodes = document.querySelectorAll('[data-option-name="Quantity"] .m-product-option--node');
      for (var i = 0; i < nodes.length; i++) {
        var val = nodes[i].getAttribute("data-value");
        var v = (product.variants || []).filter(function (x) { return x.title.indexOf(val) > -1; })[0];
        if (!v || !v.compare_at_price || v.compare_at_price <= v.price) continue;
        var saved = v.compare_at_price - v.price;
        var walker = document.createTreeWalker(nodes[i], NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
          var t = walker.currentNode.nodeValue;
          if (/SAVE\s+\d+%/i.test(t)) walker.currentNode.nodeValue = t.replace(/SAVE\s+\d+%/i, "SAVE " + moneyShort(saved));
        }
      }
    }
    dollarBadges();

    // Rotating review + benefit-badge carousel under the gallery (gonza 2026-08-11)
    (function () {
      var ROT_HANDLES = { "alma-cacao": 1, "kanna": 1, "gmood": 1 };
      if (!ROT_HANDLES[product.handle || ""]) return;
      var det = document.querySelector(".product-testi-details");
      if (!det || !det.parentElement) return;
      var host = det.parentElement;
      var stars = '<span class="bos-rot__stars">\u2605\u2605\u2605\u2605\u2605</span>';
      function review(q, n) { return stars + '<p class="bos-rot__quote">' + q + '</p><p class="bos-rot__name">' + n + "</p>"; }
      function bicon(d) {
        return '<svg class="bos-rot__bicon" viewBox="0 0 24 24" fill="none" stroke="#B8905A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + d + "</svg>";
      }
      var BICONS = {
        "100% Pure Cacao": '<ellipse cx="12" cy="12" rx="5.5" ry="8.5"/><path d="M12 3.5v17"/><path d="M9 5.5c-1.5 4-1.5 9 0 13M15 5.5c1.5 4 1.5 9 0 13"/>',
        "Zero Sugar": '<rect x="7.5" y="7.5" width="9" height="9" rx="1.5"/><path d="M4.5 19.5 19.5 4.5"/>',
        "Vegan & Plant-Based": '<path d="M12 20.5C6.5 16 5.5 9.5 12 4c6.5 5.5 5.5 12 0 16.5Z"/><path d="M12 20.5V11"/>',
        "Single-Origin Peru": '<path d="M12 21s-6-5.2-6-10a6 6 0 1 1 12 0c0 4.8-6 10-6 10Z"/><circle cx="12" cy="11" r="2.2"/>',
        "Natural Energy": '<circle cx="12" cy="12" r="4"/><path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8"/>',
        "No Fillers": '<circle cx="12" cy="12" r="8.5"/><circle cx="9.5" cy="10" r=".9" fill="#B8905A"/><circle cx="14.5" cy="9.5" r=".9" fill="#B8905A"/><circle cx="12" cy="14.5" r=".9" fill="#B8905A"/><path d="M5.5 18.5 18.5 5.5"/>',
        "Handcrafted Small Batches": '<ellipse cx="8.5" cy="10" rx="2.6" ry="3.6" transform="rotate(-18 8.5 10)"/><ellipse cx="15.5" cy="10" rx="2.6" ry="3.6" transform="rotate(18 15.5 10)"/><ellipse cx="12" cy="16" rx="2.6" ry="3.6"/>',
        "Gives Back to Origin": '<path d="M12 20s-7-4.4-7-9.3A4.1 4.1 0 0 1 12 7.6a4.1 4.1 0 0 1 7 3.1C19 15.6 12 20 12 20Z"/>',
        "Gluten Free": '<path d="M12 21V7"/><path d="M12 10c-2.5 0-4-1.5-4-4 2.5 0 4 1.5 4 4Zm0 0c2.5 0 4-1.5 4-4-2.5 0-4 1.5-4 4ZM12 15c-2.5 0-4-1.5-4-4 2.5 0 4 1.5 4 4Zm0 0c2.5 0 4-1.5 4-4-2.5 0-4 1.5-4 4Z"/><path d="M5 19.5 19 5.5"/>',
        "Dairy Free": '<path d="M9.5 3h5v3l1.5 3v11a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 8 20V9l1.5-3V3Z"/><path d="M8 12h8"/><path d="M4.5 20.5 19.5 4.5"/>',
        "No Preservatives": '<path d="M12 3l7 3v5.2c0 4.4-3 7.4-7 8.8-4-1.4-7-4.4-7-8.8V6l7-3Z"/><path d="M12 15.5c-2.6-2-2.8-5 0-7 2.8 2 2.6 5 0 7Z"/>',
        "Infused at 528 Hz": '<path d="M2.5 12c1.6-4.5 3.2-4.5 4.8 0s3.2 4.5 4.7 0 3.2-4.5 4.8 0 3.1 4.5 4.7 0"/>',
        "Ethically Sourced": '<circle cx="12" cy="12" r="8.5"/><ellipse cx="12" cy="12" rx="8.5" ry="3.4"/><path d="M12 3.5v17"/>'
      };
      BICONS["Plant-Based Botanical"] = BICONS["Vegan & Plant-Based"];
      BICONS["South African Sceletium"] = BICONS["Single-Origin Peru"];
      BICONS["Small Batches"] = BICONS["Handcrafted Small Batches"];
      BICONS["Pairs with Your Cacao"] = BICONS["100% Pure Cacao"];
      BICONS["No Jitters, No Crash"] = BICONS["Natural Energy"];
      BICONS["Plant-Powered"] = BICONS["Vegan & Plant-Based"];
      BICONS["Lion's Mane Inside"] = BICONS["No Fillers"];
      BICONS["Made in California"] = BICONS["Single-Origin Peru"];
      BICONS["Calm, Connected, Centered"] = BICONS["Gives Back to Origin"];
      BICONS["18% Total Alkaloids"] = BICONS["Natural Energy"];
      BICONS["Lab-Tested Every Lot"] = BICONS["No Preservatives"];
      function badges(list) {
        return '<div class="bos-rot__badges">' + list.map(function (b) {
          return '<span class="bos-rot__badge">' + (BICONS[b] ? bicon(BICONS[b]) : "") + b + "</span>";
        }).join("") + "</div>";
      }
      var SLIDES = {
        "alma-cacao": [
        review("What a treasure! When I drink this cacao, there is an undeniable feeling that I\u2019m taking in something very special. An enhanced feeling of wellbeing that lingers for hours.", "JENNA"),
        badges(["100% Pure Cacao", "Zero Sugar", "Vegan & Plant-Based", "Single-Origin Peru"]),
        review("This has been a game-changer for my workouts and recovery. Clean ingredients and real results. I\u2019m hooked!", "VERIFIED CUSTOMER"),
        badges(["Natural Energy", "No Fillers", "Handcrafted Small Batches", "Gives Back to Origin"]),
        review("Finally, a natural product that helps me unwind after a long day. My sleep has never been better!", "VERIFIED CUSTOMER"),
        badges(["Gluten Free", "Dairy Free", "No Preservatives", "Infused at 528 Hz"])
        ],
        "kanna": [
          review("It\u2019s a real nice mood boost\u2026 makes you feel real centered, grounded, happy, and connected. I feel a shift from the head into the heart.", "ADAM G."),
          badges(["18% Total Alkaloids", "Lab-Tested Every Lot", "South African Sceletium", "Plant-Based Botanical"]),
          review("I felt so calm and relaxed, and my energy completely shifted in the best way\u2026 I absolutely love it!", "ELISHA"),
          badges(["Calm, Connected, Centered", "Small Batches", "Pairs with Your Cacao", "Lab-Tested Every Lot"])
        ],
        "gmood": [
          review("G+MOOD has completely changed my morning routine. Focused, energized, and calm all at once. No jitters, no crash, just steady, clear energy.", "MELISSA R."),
          badges(["No Jitters, No Crash", "Plant-Powered", "Lion's Mane Inside", "Made in California"]),
          review("It\u2019s like mental clarity in a pouch\u2026 steady, clear energy that carries me through my workday. I\u2019m obsessed.", "MELISSA R."),
          badges(["Plant-Powered", "Small Batches", "No Jitters, No Crash", "Lion's Mane Inside"])
        ]
      };
      var slides = SLIDES[product.handle || ""];
      if (!slides) return;
      host.classList.add("bos-rot");
      host.innerHTML = '<div class="bos-rot__slide" data-bos-rot></div>';
      var slot = host.querySelector("[data-bos-rot]"), idx = 0;
      slot.innerHTML = slides[0];
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var paused = false;
      host.addEventListener("mouseenter", function () { paused = true; });
      host.addEventListener("mouseleave", function () { paused = false; });
      setInterval(function () {
        if (paused) return;
        idx = (idx + 1) % slides.length;
        slot.style.opacity = 0;
        setTimeout(function () { slot.innerHTML = slides[idx]; slot.style.opacity = 1; }, 350);
      }, 3000);
    })();
    setTimeout(dollarBadges, 1200);
    document.addEventListener("change", function () { setTimeout(dollarBadges, 150); }, true);

    // Gallery cleanup: variant-only images (2lb/3lb/pouch) stay on variants, not in the gallery
    function pruneGallery() {
      var pats = ["alma_cacao_2lb", "alma_cacao_3lb", "half_a_pound"];
      var removed = 0;
      document.querySelectorAll(".m-media-gallery__list .swiper-slide, .m-product-media--slider__thumbnails .swiper-slide").forEach(function (sl) {
        var img = sl.querySelector("img");
        var srcv = img ? (img.currentSrc || img.src || img.getAttribute("data-src") || "") + (img.getAttribute("srcset") || "") : "";
        if (pats.some(function (t) { return srcv.indexOf(t) > -1; })) { sl.parentNode.removeChild(sl); removed++; }
      });
      if (removed) {
        document.querySelectorAll(".swiper-container, .m-media-gallery__inner").forEach(function (c) {
          if (c.swiper && c.swiper.update) { try { c.swiper.update(); } catch (e) {} }
        });
      }
    }
    pruneGallery();
    setTimeout(pruneGallery, 1000);
    setTimeout(pruneGallery, 2500);

    // Clean display title (Alice pattern): brand name shown, SEO title kept in-DOM
    (function () {
      if ((product.handle || "") !== "alma-cacao") return;
      var h1 = document.querySelector("h1.m-product-title");
      if (!h1 || h1.querySelector(".bos-title-display")) return;
      var orig = h1.textContent.trim();
      h1.innerHTML = '<span class="bos-title-display">Alma Cacao</span>'
        + '<span class="bos-title-seo">' + orig + "</span>";
    })();

    // Compact variant cards: inline-important so theme CSS can't inflate them
    function compactCards() {
      document.querySelectorAll('[data-option-name="Quantity"] .m-product-option--node__label').forEach(function (el) {
        el.style.setProperty("padding", "5px 14px", "important");
        el.style.setProperty("min-height", "68px", "important");
      });
    }
    compactCards();
    setTimeout(compactCards, 1200);

    // Video posters: theme ignores the cover setting for hosted video, set directly
    function fixVideoPosters() {
      var POSTERS = { HH3yDE: { img: "poster-howto.jpg", seek: 6 }, QP8L8q: { img: "poster-journey.jpg", seek: 3 } };
      document.querySelectorAll(".pdp-video-mc").forEach(function (s) {
        var key = Object.keys(POSTERS).filter(function (k) { return s.id.indexOf(k) > -1; })[0];
        if (!key) return;
        var cfg = POSTERS[key];
        var url = "https://cdn.shopify.com/s/files/1/0702/7238/5254/files/" + cfg.img + "?width=1400";
        var v = s.querySelector("video");
        if (v && !v.dataset.bosPoster) {
          v.dataset.bosPoster = "1";
          v.setAttribute("poster", url);
          if (v.readyState === 0 && v.paused) { try { v.load(); } catch (e) {} }
        }
        var db = s.querySelector(".deferred-media__poster");
        if (db && !db.querySelector("img")) {
          db.style.background = "url(" + url + ") center/cover no-repeat";
        }
      });
    }
    fixVideoPosters();

    // "Real people, real results" UGC slider: Safari-safe autoplay + auto-advance
    (function () {
      var sec = document.querySelector(".pdpugc-slider-mc");
      if (!sec) return;
      function inst() { var sw = sec.querySelector(".swiper-container"); return (sw && sw.swiper) || null; }

      function primeVideos() {
        // theme leaves the <video> inside un-mounted <template>s; mount them
        sec.querySelectorAll("video-component").forEach(function (c) {
          var t = c.querySelector("template");
          if (t && !c.querySelector("video")) c.appendChild(t.content.cloneNode(true));
        });
        sec.querySelectorAll("video").forEach(function (v) {
          v.muted = true; v.setAttribute("muted", "");
          v.playsInline = true; v.setAttribute("playsinline", "");
          v.loop = true; v.setAttribute("loop", "");
          v.removeAttribute("controls");
          v.preload = "metadata";
          if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        });
      }
      new MutationObserver(primeVideos).observe(sec, { childList: true, subtree: true });

      var offscreen = true, pauseUntil = 0;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          offscreen = !e.isIntersecting;
          if (e.isIntersecting) primeVideos();
        });
      }, { threshold: 0.25 }).observe(sec);

      sec.addEventListener("touchstart", function () { pauseUntil = Date.now() + 9000; }, { passive: true });
      sec.addEventListener("pointerdown", function () { pauseUntil = Date.now() + 9000; });
      function hov() { try { return sec.matches(":hover"); } catch (e) { return false; } }
      setInterval(function () {
        if (offscreen || document.hidden || hov() || Date.now() < pauseUntil) return;
        var s = inst(); if (!s) return;
        if (s.params && s.params.loop) { s.slideNext(600); return; }
        var last = (s.slides ? s.slides.length : 0) - 1;
        if (s.activeIndex >= last) s.slideTo(0, 600); else s.slideNext(600);
      }, 3800);
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { offscreen = true; }
    })();
    if ("MutationObserver" in window) {
      document.querySelectorAll(".pdp-video-mc").forEach(function (s) {
        new MutationObserver(fixVideoPosters).observe(s, { childList: true, subtree: true });
      });
    } else {
      setTimeout(fixVideoPosters, 2000);
      setTimeout(fixVideoPosters, 6000);
    }

    // Thumbnail strip: arrows drive the MAIN gallery; strip follows the active image
    (function wireGalleryNav(tries) {
      var strip = document.querySelector(".m-product-media--slider__thumbnails");
      var mainEl = document.querySelector(".m-media-gallery__inner.swiper-container")
        || document.querySelector(".m-product-media--slider__images");
      var mainSw = mainEl && mainEl.swiper;
      if (!strip || !mainSw) {
        if (tries > 0) setTimeout(function () { wireGalleryNav(tries - 1); }, 700);
        return;
      }
      try { mainSw.params.autoHeight = false; mainSw.update(); } catch (e) {}
      var navEl = strip.querySelector(".nav-swiper-container");
      var navSw = navEl && navEl.swiper;

      function follow() {
        var idx = mainSw.realIndex != null ? mainSw.realIndex : mainSw.activeIndex;
        if (navSw && navSw.slideTo) { try { navSw.slideTo(idx); } catch (e) {} }
        else if (navEl) {
          var s = navEl.querySelectorAll(".swiper-slide")[idx];
          if (s && s.scrollIntoView) s.scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      }
      mainSw.on("slideChange", follow);

      // Autoplay: glide through the gallery; stateless pause checks at each tick
      (function () {
        var AUTO_MS = 3200, SPEED = 600, offscreen = false, pauseUntil = 0;
        function hovered() {
          try { return mainEl.matches(":hover"); } catch (e) { return false; }
        }
        function tick() {
          if (offscreen || document.hidden || hovered() || Date.now() < pauseUntil) return;
          if (mainSw.params && mainSw.params.loop) { mainSw.slideNext(SPEED); return; }
          var last = (mainSw.slides ? mainSw.slides.length : 0) - 1;
          if (mainSw.activeIndex >= last) mainSw.slideTo(0, SPEED);
          else mainSw.slideNext(SPEED);
        }
        var timer = setInterval(tick, AUTO_MS);
        function rest() { pauseUntil = Date.now() + 9000; }
        mainEl.addEventListener("touchstart", rest, { passive: true });
        mainEl.addEventListener("pointerdown", rest);
        strip.addEventListener("click", rest);
        if ("IntersectionObserver" in window) {
          new IntersectionObserver(function (es) {
            es.forEach(function (e) { offscreen = !e.isIntersecting; });
          }, { threshold: 0.25 }).observe(mainEl);
        }
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) clearInterval(timer);
      })();

      if (!strip.querySelector(".bos-thumb-arrow")) {
        [-1, 1].forEach(function (dir) {
          var b = document.createElement("button");
          b.type = "button";
          b.className = "bos-thumb-arrow bos-thumb-arrow--" + (dir < 0 ? "prev" : "next");
          b.innerHTML = dir < 0 ? "\u2039" : "\u203a";
          b.addEventListener("click", function () {
            dir < 0 ? mainSw.slidePrev() : mainSw.slideNext();
            follow();
          });
          strip.appendChild(b);
        });
      }
    })(14);

    // Order-today + guarantee box (ships Mon-Wed for freshness; USPS ~3-5 days)
    try {
      var now = new Date(), dow = now.getDay();
      var ship = new Date(now);
      if (dow === 1) ship.setDate(now.getDate() + 1);        // Mon -> ships Tue
      else if (dow === 2) ship.setDate(now.getDate() + 1);   // Tue -> ships Wed
      else ship.setDate(now.getDate() + ((8 - dow) % 7 || 7)); // Wed-Sun -> next Mon
      var a1 = new Date(ship), a2 = new Date(ship);
      a1.setDate(ship.getDate() + 3); a2.setDate(ship.getDate() + 5);
      function fmt(d) { return d.toLocaleDateString("en-US", { month: "short", day: "numeric" }); }
      var box = document.createElement("div");
      box.className = "bos-ship";
      var icoBox = '<svg class="bos-ship__ico" viewBox="0 0 24 24" fill="none" stroke="#B8905A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 8.5v7a2 2 0 0 1-1 1.73l-6 3.5a2 2 0 0 1-2 0l-6-3.5A2 2 0 0 1 5 15.5v-7a2 2 0 0 1 1-1.73l6-3.5a2 2 0 0 1 2 0l6 3.5a2 2 0 0 1 1 1.73Z"/><path d="M5.3 7 13 11.5 20.7 7"/><path d="M13 22V11.5"/></svg>';
      var icoShield = '<svg class="bos-ship__ico" viewBox="0 0 24 24" fill="none" stroke="#B8905A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5 4.5 5.5v6c0 4.6 3.2 7.9 7.5 9.5 4.3-1.6 7.5-4.9 7.5-9.5v-6L12 2.5Z"/><path d="m8.8 12 2.2 2.2 4.2-4.4"/></svg>';
      box.innerHTML =
        '<div class="bos-ship__row">' + icoBox + '<span><strong>Order today</strong>, ships ' + ship.toLocaleDateString("en-US", { weekday: "short" }) + " " + fmt(ship) + " \u00b7 arrives " + fmt(a1) + "\u2013" + fmt(a2) + "</span></div>"
        + '<div class="bos-ship__row">' + icoShield + '<span><strong>30-day money-back guarantee</strong></span></div>';
      var buyNow = document.querySelector('[id^="AlmaBuyNow-"]');
      if (buyNow && buyNow.parentNode) buyNow.parentNode.insertBefore(box, buyNow.nextSibling);
      else wrap.appendChild(box);
    } catch (e) {}

    // ── Buy-box conversion layer (gonza 2026-08-18, "5 things" framework) ──
    // Config-driven per product: badge, 3 benefits, review card, urgency, FAQ.
    (function () {
      var CONV = {
        "alma-cacao": {
          badge: "Served in studios &amp; cafés across America",
          benefits: [
            "Calm, steady energy. No crash, no jitters",
            "Coffee alternative: 6 hours of focused energy",
            "A superfood in every cup: vitamins, minerals &amp; amino acids"
          ],
          review: {
            name: "Dr. Marley Stubblefield",
            quote: "“Seriously the best cacao I’ve ever had… creamy and thick… and I’d consider myself a cacao aficionado!”",
            img: "https://cdn.shopify.com/s/files/1/0702/7238/5254/files/buybox-review-thumb.jpg?v=1787087321&width=132",
            alt: "Alma cacao cup held in hands"
          },
          urgency: "<strong>Order by Wednesday 2 PM</strong>. Later orders ship Monday to protect your cacao from summer heat. Roasted in small batches, monthly.",
          faq: [
            { q: "“Isn’t this just fancy hot chocolate?”",
              a: "Hot chocolate is cocoa powder and sugar, with the cacao butter and most nutrients stripped out. Alma is the whole ceremonial cacao bean, stone-ground with nothing removed and nothing added. You drink it for the calm, focused energy and the minerals, not for dessert. The rich taste is the bonus." },
            { q: "“Will I miss my coffee?”",
              a: "Cacao runs on theobromine, a gentler cousin of caffeine. Instead of a spike and a 3pm crash, you get a smooth lift that lasts about 6 hours. Most people transition within a few days, and you keep the part you actually love: the warm cup that starts your morning." }
          ]
        },
        "kanna": {
          badge: "Served in advanced wellness clinics across America",
          benefits: [
            "Feel calm, connected, centered",
            "18% total alkaloids, mesembrine-dominant",
            "Fast acting: felt in 5 to 10 minutes under the tongue"
          ],
          review: {
            name: "Cody Sims, MS, PA-C",
            quote: "“A calm, grounded energy… it increases emotional openness and awareness, and enhances mood and sociability.”",
            img: "https://cdn.shopify.com/s/files/1/0702/7238/5254/files/buybox-review-cody-sims.jpg?v=1787968225&width=132",
            alt: "Cody Sims, MS, PA-C, physician assistant, Kensho Wellbeing"
          },
          urgency: "<strong>Order by Wednesday 2 PM</strong> to ship this week. Bottled in small batches.",
          faq: [
            { q: "“Is Kanna like kratom?”",
              a: "No. Kanna is Sceletium tortuosum, a South African botanical used for centuries for calm and connection. It is gentle and works differently from kratom. Start with one serving and feel your way." },
            { q: "“Can I take it with my medication?”",
              a: "Kanna works on the serotonin system. Do not combine it with alcohol, SSRIs, or antidepressants. If you take any medication, please check with your doctor first." }
          ]
        },
        "gmood": {
          badge: "Crafted in small batches in California",
          benefits: [
            "Clarity and focus, without the crash",
            "One capsule before your day starts",
            "Botanicals for steady focus &amp; mood"
          ],
          review: null,
          urgency: "<strong>Order by Wednesday 2 PM</strong> to ship this week. Made in small batches.",
          faq: [
            { q: "“When do I take it?”",
              a: "One capsule at the start of your day, before the work begins. Steady clarity through the day, on your terms." },
            { q: "“What does ‘without the crash’ mean?”",
              a: "No spike-and-drop cycle. G+mood is built for steady focus and mood through the day, so 3pm feels like 10am. Start with one capsule and feel your way." }
          ]
        }
      };
      var CFG = CONV[product.handle || ""];
      if (!CFG) return;

      var h1 = document.querySelector("h1.m-product-title");
      var titleBlock = document.querySelector(".main-product__block-title") || (h1 && h1.parentNode);

      // 1. Credibility badge above the whole title block
      if (titleBlock && titleBlock.parentNode && !document.querySelector(".bos-cred")) {
        var cred = document.createElement("div");
        cred.className = "bos-cred";
        cred.innerHTML = '<span class="bos-cred__chk">✓</span> ' + CFG.badge;
        titleBlock.parentNode.insertBefore(cred, titleBlock);
      }

      // 2. Three bold benefits after the subtitle block
      if (titleBlock && !document.querySelector(".bos-benefits")) {
        var anchor = titleBlock;
        var nxt = titleBlock.nextElementSibling;
        if (nxt && !nxt.querySelector("form") && (nxt.textContent || "").trim().length < 140) anchor = nxt;
        var ben = document.createElement("div");
        ben.className = "bos-benefits";
        ben.innerHTML = CFG.benefits.map(function (t) {
          return '<div class="bos-benefit"><span class="bos-benefit__chk">✓</span><span>' + t + "</span></div>";
        }).join("");
        anchor.parentNode.insertBefore(ben, anchor.nextSibling);

        // 3. Review card + divider (only when a real review exists)
        if (CFG.review) {
          var rev = document.createElement("div");
          rev.className = "bos-buyrev";
          var pic = CFG.review.img
            ? '<img class="bos-buyrev__pic" src="' + CFG.review.img + '" alt="' + (CFG.review.alt || "") + '" loading="lazy" width="66" height="66">'
            : '<div class="bos-buyrev__avatar">' + (CFG.review.initial || "A") + "</div>";
          rev.innerHTML = pic
            + '<div><div class="bos-buyrev__who">' + CFG.review.name + ' <span class="bos-buyrev__vrf">✓</span> <span class="bos-buyrev__stars">★★★★★</span></div>'
            + '<p class="bos-buyrev__quote">' + CFG.review.quote + "</p></div>";
          ben.parentNode.insertBefore(rev, ben.nextSibling);
          var div = document.createElement("div");
          div.className = "bos-buyrev-divider";
          rev.parentNode.insertBefore(div, rev.nextSibling);
        } else {
          var div2 = document.createElement("div");
          div2.className = "bos-buyrev-divider";
          ben.parentNode.insertBefore(div2, ben.nextSibling);
        }
      }

      // 4. Urgency with pulsing dot, above the add-to-cart button
      if (!document.querySelector(".bos-urgency")) {
        var urg = document.createElement("div");
        urg.className = "bos-urgency";
        urg.innerHTML = '<span class="bos-urgency__dot"></span><span>' + CFG.urgency + "</span>";
        var atc = form.querySelector('button[name="add"], .m-add-to-cart');
        var slot = atc;
        while (slot && slot.parentElement !== form && slot.parentElement !== wrap.parentElement) slot = slot.parentElement;
        if (atc) (slot || atc).parentNode.insertBefore(urg, slot || atc);
        else wrap.appendChild(urg);
      }

      // 5. Payment-brand chips + guarantee after Buy Now
      if (!document.querySelector(".bos-paytrust")) {
        var pay = document.createElement("div");
        pay.className = "bos-paytrust";
        pay.innerHTML =
          '<span class="bos-paychips">'
          + '<span class="bos-chip bos-chip--visa">VISA</span>'
          + '<span class="bos-chip bos-chip--mc"><i></i><i></i></span>'
          + '<span class="bos-chip bos-chip--amex">AMEX</span>'
          + '<span class="bos-chip bos-chip--apay"> Pay</span>'
          + '<span class="bos-chip bos-chip--shop">shop</span>'
          + '<span class="bos-chip bos-chip--pp"><em>Pay</em><b>Pal</b></span>'
          + "</span>"
          + '<span class="bos-paytrust__gt">' + (CFG.guarantee || "✓ 30-day money-back") + '</span>';
        var bn = document.querySelector('[id^="AlmaBuyNow-"]');
        if (bn && bn.parentNode) bn.parentNode.insertBefore(pay, bn.nextSibling);
      }

      // 6. Objection-led FAQ under the ship box
      if (!document.querySelector(".bos-objections")) {
        var obj = document.createElement("div");
        obj.className = "bos-objections";
        obj.innerHTML = CFG.faq.map(function (f) {
          return '<details class="bos-obj"><summary>' + f.q + "</summary><p>" + f.a + "</p></details>";
        }).join("");
        var shipBox = document.querySelector(".bos-ship");
        if (shipBox && shipBox.parentNode) shipBox.parentNode.insertBefore(obj, shipBox.nextSibling);
        else wrap.appendChild(obj);
      }

      // Ship box guarantee row is redundant now (chips row carries it)
      var shieldRows = document.querySelectorAll(".bos-ship__row");
      if (document.querySelector(".bos-paytrust") && shieldRows.length > 1) {
        var last = shieldRows[shieldRows.length - 1];
        if (/money-back/i.test(last.textContent || "")) last.parentNode.removeChild(last);
      }
    })();
  }

  function wire(wrap, sp, form, product, plans) {
    var freq = wrap.querySelector("[data-bos-freq]");
    var planSel = wrap.querySelector("[data-bos-plan]");
    var oneEl = wrap.querySelector("[data-bos-onetime]");
    var subEl = wrap.querySelector("[data-bos-subprice]");
    var wasEl = wrap.querySelector("[data-bos-was]");
    var titleEl = wrap.querySelector("[data-bos-title]");
    var noteEl = wrap.querySelector("[data-bos-note]");
    var percupEl = wrap.querySelector("[data-bos-percup]");
    var optOne = wrap.querySelector("[data-bos-optone]");
    var optSub = wrap.querySelector("[data-bos-optsub]");
    var idInput = form.querySelector('input[name="id"]');

    function variant() {
      var vid = idInput ? parseInt(idInput.value, 10) : null;
      return (product.variants || []).filter(function (x) { return x.id === vid; })[0] || null;
    }
    function allocs(v) {
      return v ? (v.selling_plan_allocations || []).filter(function (a) { return plans[a.selling_plan_id]; }) : [];
    }

    function refresh() {
      var v = variant();
      var price = v ? v.price : (product.price || 0);
      // Shop Pay installments banner: follow the selected variant
      if (v) {
        var pt = document.querySelector("shopify-payment-terms");
        if (pt) pt.setAttribute("variant-id", String(v.id));
        var ptInput = document.querySelector("#bos-installments-form input[name=\"id\"], .bos-installments input[name=\"id\"]");
        if (ptInput) ptInput.value = String(v.id);
      }
      var al = allocs(v);
      if (oneEl) oneEl.textContent = money(price);

      if (!al.length) {
        optSub.style.display = "none";
        var one = wrap.querySelector('input[value="onetime"]');
        if (one) one.checked = true;
        syncPlan();
        return;
      }
      optSub.style.display = "";

      var prev = planSel.selectedIndex >= 0 ? planSel.selectedIndex : 0;
      planSel.innerHTML = al.map(function (a) {
        var pl = plans[a.selling_plan_id];
        return '<option value="' + a.selling_plan_id + '">' + cadence(pl ? pl.name : "") + "</option>";
      }).join("");
      planSel.selectedIndex = Math.min(prev, al.length - 1);

      var sel = al[planSel.selectedIndex] || al[0];
      var pct = Math.round((1 - sel.per_delivery_price / price) * 100);
      var saveAmt = price - sel.per_delivery_price;
      if (titleEl) titleEl.textContent = pct <= 12 ? "Subscribe & Save an extra " + moneyShort(saveAmt) : "Subscribe & Save " + moneyShort(saveAmt);
      if (subEl) subEl.textContent = money(sel.per_delivery_price);
      if (wasEl) wasEl.textContent = money(price);
      if (percupEl) {
        var cfg = PERCUP[(product.handle || "")];
        var rows = "";
        if (cfg && v) {
          rows += '<span class="bos-sub__pill">About ' + moneyShort(Math.round(sel.per_delivery_price / cfg.count(v))) + " " + cfg.unit + "</span>";
          if (cfg.extra) rows += '<span class="bos-sub__perk">' + cfg.extra + "</span>";
          if (cfg.extra2) rows += '<span class="bos-sub__perk">' + cfg.extra2 + "</span>";
        }
        rows += '<span class="bos-sub__perk">Skip, pause, or cancel anytime</span>';
        percupEl.innerHTML = rows;
      }
      if (noteEl) {
        noteEl.textContent = pct <= 12
          ? "This size is already bulk-discounted. Subscribing saves an extra " + moneyShort(saveAmt) + " on every order. Skip or cancel anytime."
          : "Save " + moneyShort(saveAmt) + " on every order. Skip, pause, or cancel anytime.";
      }
      syncPlan();
    }

    function syncPlan() {
      var checked = wrap.querySelector('input[name="bos-ptype"]:checked');
      var isSub = checked && checked.value === "subscribe" && optSub.style.display !== "none";
      freq.hidden = !isSub;
      optOne.classList.toggle("is-active", !isSub);
      optSub.classList.toggle("is-active", isSub);
      if (isSub && planSel.value) { sp.value = planSel.value; sp.disabled = false; }
      else { sp.value = ""; sp.disabled = true; }
    }

    var radios = wrap.querySelectorAll('input[name="bos-ptype"]');
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener("change", syncPlan);
    if (planSel) planSel.addEventListener("change", syncPlan);
    document.addEventListener("variant:changed", refresh);
    if (idInput) idInput.addEventListener("change", refresh);
    form.addEventListener("submit", function () { stripForeignPlanInputs(form); syncPlan(); }, true);

    refresh();
  }

  function hideStay() {
    var sel = document.querySelector('[name="stayai_selling_plan"]');
    if (!sel) return;
    var el = sel;
    for (var i = 0; i < 7 && el; i++) {
      el = el.parentElement;
      if (!el) break;
      var txt = (el.textContent || "").replace(/\s+/g, " ");
      if (/one[- ]?time/i.test(txt) && /subscribe/i.test(txt) && txt.length < 500) { el.style.display = "none"; return; }
    }
    var box = sel.closest("div");
    if (box) box.style.display = "none";
  }

  function injectStyles() {
    if (document.getElementById("bos-sub-styles")) return;
    var s = document.createElement("style");
    s.id = "bos-sub-styles";
    s.textContent =
      ".bos-sub{margin:16px 0;display:flex;flex-direction:column;gap:10px;font-family:inherit}"
      + ".bos-sub__opts{display:flex;flex-direction:column;gap:10px}"
      + ".bos-sub__opt{position:relative;display:flex;align-items:center;gap:12px;padding:14px 16px;border:1.5px solid #e4e4e4;border-radius:12px;cursor:pointer;transition:border-color .18s,background .18s}"
      + ".bos-sub__opt:hover{border-color:#c9a86a}"
      + ".bos-sub__opt.is-active{border-color:#e8b854;background:#fffaf0}"
      + ".bos-sub__opt--sub{border-color:#e3c98f;background:linear-gradient(135deg,#fffaf0 0%,#fbf0da 55%,#f7e7c6 100%);overflow:hidden;padding-top:26px;align-items:flex-start}"
      + ".bos-sub__opt--sub .bos-sub__radio{margin-top:1px}"
      + ".bos-sub__opt--sub.is-active{border-color:#d9a83f;box-shadow:0 4px 18px rgba(201,143,1,.22)}"
      + ".bos-sub__opt--sub::after{content:\"\";position:absolute;top:0;left:-70%;width:45%;height:100%;pointer-events:none;background:linear-gradient(105deg,transparent,rgba(255,255,255,.6),transparent);transform:skewX(-20deg);animation:bosShine 5.5s ease-in-out infinite}"
      + "@keyframes bosShine{0%{left:-70%}22%{left:125%}100%{left:125%}}"
      + "@media (prefers-reduced-motion: reduce){.bos-sub__opt--sub::after{animation:none;display:none}}"
      + ".bos-sub__radio{flex:0 0 auto;display:inline-flex}"
      + ".bos-sub__radio input{width:18px;height:18px;accent-color:#c98f01;margin:0;cursor:pointer}"
      + ".bos-sub__body{flex:1;display:flex;align-items:baseline;justify-content:space-between;gap:10px;flex-wrap:wrap}"
      + ".bos-sub__title{font-weight:600;font-size:15px;color:#222}"
      + ".bos-sub__price{font-weight:600;font-size:15px;color:#222;white-space:nowrap}"
      + ".bos-sub__was{color:#9a8a73;text-decoration:line-through;font-weight:500;margin-left:4px;font-size:13px}"
      + ".bos-sub__badge{position:absolute;top:8px;right:12px;background:#e8b854;color:#3a2a08;font-size:10px;font-weight:700;letter-spacing:.05em;text-transform:uppercase;padding:3px 9px;border-radius:999px;z-index:1}"
      + ".bos-sub__freq-label{display:block;font-size:12px;font-weight:600;letter-spacing:.03em;color:#6b5a3a;margin:2px 0 6px;text-transform:uppercase}"
      + ".bos-sub__freq-select{width:100%;padding:11px 14px;border:1.5px solid #e4e4e4;border-radius:10px;font-size:14px;color:#222;background:#fff}"
      + ".bos-sub__freq-select:focus{outline:none;border-color:#e8b854}"
      + ".bos-sub__note{margin:8px 0 0;font-size:12px;line-height:1.5;color:#8a7b66}"
      + ".bos-sub__perks{flex-basis:100%;display:flex;flex-direction:column;align-items:flex-start;gap:6px;margin-top:7px}"
      + ".bos-sub__perks:empty{display:none}"
      + ".bos-sub__pill{display:inline-flex;align-items:center;gap:6px;background:linear-gradient(90deg,#f0dcb2,#e8c98a);color:#5d431a;font-size:12.5px;font-weight:700;letter-spacing:.02em;padding:4px 12px;border-radius:999px;box-shadow:0 1px 4px rgba(160,120,40,.18)}"
      + ".bos-sub__pill::before{content:\"\";width:6px;height:6px;border-radius:50%;background:#a4740f}"
      + ".bos-sub__perk{display:inline-flex;align-items:center;gap:7px;font-size:12.5px;color:#6f5b40;font-weight:500}"
      + ".bos-sub__perk::before{content:\"\u2713\";color:#b98a2e;font-weight:700;font-size:12px}"
      // buy-box cleanups (gonza 2026-08-11): hide sticky ATC + "Quantity:" label, compact title
      + ".m-sticky-addtocart{display:none!important}"
      + "[data-option-name=\"Quantity\"] .m-product-option--label{display:none!important}"
      + ".m-product-title{font-size:clamp(20px,2.4vw,27px)!important;line-height:1.2!important}"
      + ".bos-title-display{display:block;font-family:'Lora',Georgia,serif;font-weight:400;text-transform:none;letter-spacing:.02em;font-size:clamp(34px,4.2vw,46px);line-height:1.05;color:#3B2A1E}"
      + ".bos-title-seo{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}"
      // hide single-flavor row, thumbnails in quantity cards
      + ".m-product-option:has([data-option-name=\"FLAVOR\"]){display:none!important}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node__label{display:flex!important;align-items:center;gap:12px;padding:2px 14px!important;min-height:45px}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node{margin:0!important}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node__label .variant-pricing{margin-left:auto}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node__label::before{content:\"\";flex:0 0 54px;width:54px;height:54px;margin:-8px 0;border-radius:8px;background:center/contain no-repeat}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node[data-value=\"1 lb\"] .m-product-option--node__label::before{background-image:url(https://cdn.shopify.com/s/files/1/0702/7238/5254/files/qty-single-1lb.png?width=108)}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node[data-value=\"\u00bd lb - Cacao Starter\"] .m-product-option--node__label::before{background-image:url(https://cdn.shopify.com/s/files/1/0702/7238/5254/files/qty-pouch-half.png?width=96)}"
      + "[data-option-name=\"Quantity\"] .m-product-option--content{display:flex;flex-direction:column;gap:8px}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node[data-value=\"\u00bd lb - Cacao Starter\"]{order:-1}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node[data-value=\"2 lb\"] .m-product-option--node__label::before{background-image:url(https://cdn.shopify.com/s/files/1/0702/7238/5254/files/qty-duo-2lb.png?width=108)}"
      + "[data-option-name=\"Quantity\"] .m-product-option--node[data-value=\"3 lb\"] .m-product-option--node__label::before{background-image:url(https://cdn.shopify.com/s/files/1/0702/7238/5254/files/qty-trio-3lb.png?width=120)}"
      // order-today / guarantee box
      + ".bos-ship{margin:12px 0 4px;border:1.5px solid #e7d7b4;border-radius:12px;background:#fffdf7;padding:12px 14px;display:flex;flex-direction:column;gap:8px}"
      + ".bos-ship__row{display:flex;align-items:center;gap:10px;font-size:13px;color:#4a3a24}"
      + ".bos-ship__row strong{font-weight:700;color:#3B2A1E}"
      + ".bos-ship__ico{flex:0 0 auto;width:19px;height:19px}"
      + ".bos-rot{min-height:150px;display:flex;align-items:center;justify-content:center;text-align:center}"
      + ".bos-rot__slide{transition:opacity .35s ease;opacity:1;width:100%}"
      + ".bos-rot__stars{color:#C9A86A;font-size:15px;letter-spacing:3px;display:block;margin-bottom:6px}"
      + ".bos-rot__quote{margin:0 auto 8px;max-width:520px;font-family:Georgia,\"Times New Roman\",serif;font-size:15.5px;line-height:1.5;color:#3B2A1E}"
      + ".bos-rot__name{margin:0;font-size:11px;font-weight:700;letter-spacing:.16em;color:#8a755a}"
      + ".bos-rot__badges{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;max-width:440px;margin:0 auto;padding:6px 0}"
      + ".bos-rot__badge{display:inline-flex;align-items:center;justify-content:center;gap:7px;border:1px solid rgba(201,168,106,.55);background:#fffaf0;border-radius:999px;padding:9px 12px;font-size:12.5px;font-weight:600;color:#5d431a}"
      + ".bos-rot__bicon{width:24px;height:24px;flex:0 0 auto}"
      + ".bos-strip{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:10px;margin:2px 0 12px}"
      + ".bos-strip__item{display:inline-flex;align-items:center;gap:7px;font-size:13px;font-weight:600;color:#5d431a}"
      + ".bos-strip__item svg{width:20px;height:20px;flex:0 0 auto}"
      + ".bos-strip__dash{color:#C9A86A;font-weight:400}"
      // PDP video sections: warm framed players + serif headings
      + ".pdp-video-mc .m-video__wrapper{max-width:1120px;margin-left:auto;margin-right:auto;border-radius:26px;overflow:hidden;border:1px solid rgba(201,168,106,.35);box-shadow:0 14px 40px rgba(59,42,30,.14);background:#FBF4E9}"
      + ".pdp-video-mc video,.pdp-video-mc iframe{border-radius:26px;display:block}"
      + ".pdp-video-mc .m-section-header__heading,.pdp-video-mc .m-section__heading{font-family:'Lora',Georgia,serif!important;font-weight:400!important;text-transform:none!important;letter-spacing:-.01em!important;font-size:clamp(30px,4.4vw,46px)!important;color:#3B2A1E!important;line-height:1.08!important}"
      + ".pdp-video-mc .m-section-header{margin-bottom:22px}"
      // PDP serif voice = Lora everywhere our serif shows
      + ".bos-title-display,.alma-vs-head h3,.alma-vs-head p,.alma-vs-points li,.alma-vs-endlabel,"
      + ".alma-why-head h3,.alma-why-head p,.alma-why-label,.alma-why-item p,"
      + ".alma-frequency-content h3,.alma-serving-header h3,.alma-faq-header h3,"
      + ".wyf-title,.wyf-line,.waf-title,.waf-line,.waf-final,.bos-rot__quote"
      + "{font-family:'Lora',Georgia,serif!important}"
      // PDP typography unification: all section headings in the serif voice
      + ".m-image-with-text .m-content-box__heading,.m-section-header__heading,.m-section__heading,.m-hero__title,.jdgm-rev-widg__title{font-family:'Lora',Georgia,serif!important;font-weight:400!important;text-transform:none!important;letter-spacing:-.01em!important}"
      + ".m-media-gallery__inner .swiper-wrapper{height:auto!important;align-items:stretch}"
      + ".m-media-gallery__list .swiper-slide{height:auto!important}"
      + ".m-media-gallery__list .swiper-slide .m-product-media{aspect-ratio:1/1!important;width:100%;height:auto!important;position:relative;overflow:hidden;background:#FBF4E9}"
      + ".m-media-gallery__list .swiper-slide .m-product-media responsive-image,.m-media-gallery__list .swiper-slide .m-product-media video-media,.m-media-gallery__list .swiper-slide .m-product-media external-video{position:absolute!important;inset:0!important;width:100%!important;height:100%!important}"
      + ".m-media-gallery__list .swiper-slide .m-product-media img,.m-media-gallery__list .swiper-slide .m-product-media video,.m-media-gallery__list .swiper-slide .m-product-media iframe{width:100%!important;height:100%!important;object-fit:contain!important}"
      + ".m-product-media--slider__navigation{display:block!important}"
      + ".m-product-media--slider__navigation .swiper-button-prev,.m-product-media--slider__navigation .swiper-button-next{display:flex!important;opacity:1!important}"
      + ".m-product-media--slider__thumbnails{position:relative;display:block!important}"
      + ".m-product-media--slider__pagination{display:none!important}"
      + ".bos-thumb-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:5;width:30px;height:30px;border-radius:50%;border:1px solid rgba(59,42,30,.25);background:#fff;color:#3B2A1E;font-size:15px;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.12)}"
      + "[id$=__custom_liquid_zHJA6K] p,[id$=__pdp_image_with_text_tGCkji] p,[id$=__pdp_image_with_text_xkE9xh] li,[id$=__pdp_image_with_text_xkE9xh] p{font-family:'Lora',Georgia,serif!important;font-size:18.5px!important;line-height:1.65!important;letter-spacing:normal!important}"
      + "[id$=__pdp_image_with_text_BWnRpK] .m-content-box{text-align:center!important}"
      + "[id$=__pdp_image_with_text_BWnRpK] .m-content-box__heading{font-family:'Lora',Georgia,serif!important;text-transform:none!important;text-align:center!important;font-size:clamp(26px,2.5vw,34px)!important;line-height:1.42!important;font-weight:400!important;max-width:none!important;width:100%!important;margin:0 auto!important;color:#4A3728!important}"
      + "[id$=__pdp_image_with_text_DBLXdw] h5{font-family:'Lora',Georgia,serif!important;text-transform:none!important;letter-spacing:normal!important;font-weight:500!important;font-size:19px!important}"
      + "[id$=__pdp_image_with_text_tGCkji] h5{font-family:'Inter','Jost',sans-serif!important;letter-spacing:.13em!important;font-weight:600!important;font-size:13.5px!important}"
      + ".bos-thumb-arrow--prev{left:-6px}.bos-thumb-arrow--next{right:-6px}"
      // Buy-box conversion layer (2026-08-18)
      + ".bos-cred{display:inline-flex;align-items:center;gap:7px;background:#8C5A3B;color:#fff;border-radius:999px;padding:6px 14px;font-size:12.5px;font-weight:600;letter-spacing:.01em;margin:0 0 10px;font-family:'Inter','Jost',sans-serif}"
      + ".bos-cred__chk{font-size:11px}"
      + ".bos-benefits{display:flex;flex-direction:column;gap:7px;margin:12px 0 2px}"
      + ".bos-benefit{display:flex;align-items:center;gap:9px;font-size:15px;font-weight:600;color:#3B2A1E;font-family:'Inter','Jost',sans-serif}"
      + ".bos-benefit__chk{flex:0 0 20px;width:20px;height:20px;border-radius:50%;background:rgba(201,168,106,.22);color:#8C6A38;font-size:12px;font-weight:800;display:inline-flex;align-items:center;justify-content:center}"
      + ".bos-buyrev{display:flex;gap:11px;align-items:flex-start;background:#fff;border:1.5px solid #e7d7b4;border-radius:14px;padding:12px 14px;margin:12px 0 2px}"
      + ".bos-buyrev__pic{flex:0 0 66px;width:66px;height:66px;border-radius:10px;object-fit:cover;display:block}"
      + ".bos-buyrev__avatar{flex:0 0 54px;width:54px;height:54px;border-radius:10px;background:linear-gradient(135deg,#C9A86A,#8C5A3B);color:#fff;font-weight:700;font-size:19px;display:flex;align-items:center;justify-content:center}"
      + ".bos-buyrev-divider{border-top:1.5px solid #d9cbae;margin:16px 0 14px}"
      + ".bos-buyrev__who{font-size:12.5px;font-weight:700;color:#3B2A1E;font-family:'Inter','Jost',sans-serif}"
      + ".bos-buyrev__vrf{color:#3897f0;font-size:12px}"
      + ".bos-buyrev__stars{color:#C9A86A;font-size:11.5px;letter-spacing:1px}"
      + ".bos-buyrev__quote{margin:4px 0 0;font-family:'Lora',Georgia,serif;font-style:italic;font-size:13.5px;line-height:1.5;color:#5d5142}"
      + ".bos-urgency{display:flex;gap:10px;align-items:flex-start;background:#FDF1E3;border:1px solid #E8C9A0;border-radius:12px;padding:11px 13px;font-size:13px;line-height:1.5;color:#4a3a24;margin:12px 0;font-family:'Inter','Jost',sans-serif}"
      + ".bos-urgency strong{color:#8C4A1E;font-weight:700}"
      + ".bos-urgency__dot{flex:0 0 10px;width:10px;height:10px;border-radius:50%;background:#C96A2B;margin-top:5px;animation:bosPulse 1.6s ease-in-out infinite}"
      + "@keyframes bosPulse{0%,100%{transform:scale(.7);opacity:.65}50%{transform:scale(1.3);opacity:1}}"
      + "@media (prefers-reduced-motion:reduce){.bos-urgency__dot{animation:none}}"
      + ".bos-paytrust{display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;margin:10px 0 2px}"
      + ".bos-paychips{display:inline-flex;gap:5px;flex-wrap:wrap}"
      + ".bos-chip{display:inline-flex;align-items:center;justify-content:center;border:1px solid #ddd2bc;background:#fff;border-radius:5px;font-size:9.5px;font-weight:800;padding:4px 8px;color:#4a4335;min-width:38px;font-family:'Inter','Jost',sans-serif}"
      + ".bos-chip--visa{color:#1A1F71;font-style:italic}"
      + ".bos-chip--mc i{display:inline-block;width:12px;height:12px;border-radius:50%;background:#EB001B}.bos-chip--mc i+i{background:#F79E1B;margin-left:-5px;mix-blend-mode:multiply}"
      + ".bos-chip--amex{background:#006FCF;color:#fff;border-color:#006FCF;font-size:8.5px}"
      + ".bos-chip--apay{background:#000;color:#fff;border-color:#000}"
      + ".bos-chip--shop{background:#5A31F4;color:#fff;border-color:#5A31F4;text-transform:lowercase;font-weight:700}"
      + ".bos-chip--pp em{color:#003087;font-style:italic;font-weight:800}.bos-chip--pp b{color:#009CDE;font-style:italic}"
      + ".bos-paytrust__gt{font-size:11.5px;font-weight:700;color:#4E7C4E;font-family:'Inter','Jost',sans-serif}"
      + ".bos-objections{margin:14px 0 4px;border-top:1px solid #e7d7b4;padding-top:6px}"
      + ".bos-obj{border-bottom:1px solid #eee3cd;padding:10px 0}"
      + ".bos-obj summary{cursor:pointer;list-style:none;display:flex;justify-content:space-between;align-items:center;font-family:'Lora',Georgia,serif;font-size:16.5px;color:#3B2A1E}"
      + ".bos-obj summary::-webkit-details-marker{display:none}"
      + ".bos-obj summary::after{content:\"\\2304\";font-size:15px;color:#8a755a;transition:transform .2s}"
      + ".bos-obj[open] summary::after{transform:rotate(180deg)}"
      + ".bos-obj p{margin:8px 0 2px;font-size:13.5px;line-height:1.6;color:#5d5142;font-family:'Inter','Jost',sans-serif}";
    document.head.appendChild(s);
  }
})();

// ---- Kanna PDP typography unification (Berthier 2026-08-28): same system as cacao.
// One serif (Lora, sentence case) for every heading, one sans (Inter) for body,
// caps only as small tracked micro-labels on feature cards.
(function () {
  if (!/\/products\/kanna(\/|$|\?)/.test(location.pathname + location.search) && !/\/products\/kanna/.test(location.pathname)) return;
  if (document.getElementById("bos-kanna-typo")) return;
  var st = document.createElement("style"); st.id = "bos-kanna-typo";
  st.textContent =
    // headings: serif, sentence case, calm weight
    '[id^="shopify-section-template"]:not([id$="__main"]):not([id$="__bos_spatial_hero"]):not([id$="__bos_zoom_parallax"]) :is(h1,h2,h3,h4,h5,h6):not(.bos-scrub-reveal__h):not(.bos-zp__cap h2),'
    + '[id^="shopify-section-template"]:not([id$="__main"]):not([id$="__bos_spatial_hero"]):not([id$="__bos_zoom_parallax"]) :is(.m-section__heading,.m-section-header__heading,.m-richtext__title,.m-content-box__heading,.iwt-top-head,.m-image-card__title,.m-accordion--item-title,.m-collapsible--title)'
    + '{font-family:"Lora",Georgia,serif!important;font-weight:400!important;text-transform:none!important;letter-spacing:-.01em!important;line-height:1.15!important;color:#3B2A1E!important}'
    // heading scale
    + '[id^="shopify-section-template"]:not([id$="__main"]):not([id$="__bos_spatial_hero"]):not([id$="__bos_zoom_parallax"]) :is(h2,.m-section__heading,.m-section-header__heading){font-size:clamp(30px,4vw,44px)!important}'
    + '[id^="shopify-section-template"]:not([id$="__main"]):not([id$="__bos_spatial_hero"]):not([id$="__bos_zoom_parallax"]) :is(h3,.m-richtext__title,.iwt-top-head){font-size:clamp(24px,2.6vw,32px)!important}'
    + '[id^="shopify-section-template"]:not([id$="__main"]):not([id$="__bos_spatial_hero"]):not([id$="__bos_zoom_parallax"]) :is(h4,h5,h6,.m-image-card__title){font-size:19px!important;font-weight:500!important;line-height:1.3!important}'
    // feature-card labels (text-with-middle-image, image-cards, vs table): small tracked sans labels
    + '[id$="__text_with_middle_image_two_h8ycVe"] .m-feature-card__title,[id$="__text_with_middle_image_two_h8ycVe"] h5,[id$="__text_with_middle_image_two_h8ycVe"] h4,'
    + '[id$="__one_vs_another_product_nCCAnz"] h5,[id$="__one_vs_another_product_nCCAnz"] h4'
    + '{font-family:"Inter","Jost",sans-serif!important;font-weight:600!important;font-size:12.5px!important;letter-spacing:.12em!important;text-transform:uppercase!important;color:#6B5238!important;line-height:1.35!important}'
    // body copy: one sans, one size
    + '[id^="shopify-section-template"]:not([id$="__main"]):not([id$="__bos_spatial_hero"]):not([id$="__bos_zoom_parallax"]) :is(p,li,.m-feature-card__text,.m-image-card__text,.m-richtext__text)'
    + '{font-family:"Inter","Jost",sans-serif!important;font-weight:400!important;font-size:16px!important;line-height:1.6!important;letter-spacing:normal!important;text-transform:none!important}'
    + '[id^="shopify-section-template"]:not([id$="__main"]):not([id$="__bos_spatial_hero"]):not([id$="__bos_zoom_parallax"]) :is(p,li) strong{font-weight:600!important}'
    // buttons/links keep their weight but drop caps shouting
    + '[id^="shopify-section-template"]:not([id$="__main"]):not([id$="__bos_spatial_hero"]):not([id$="__bos_zoom_parallax"]) .m-button{font-family:"Inter","Jost",sans-serif!important;text-transform:none!important;letter-spacing:.01em!important;font-weight:600!important}'
    // feature cards (small batch): first line = card title in serif, rest = body
    + 'html body [id^="shopify-section-template"][id$="__text_with_middle_image_two_h8ycVe"][id] [class*="icons-title"][class][class] p,html body [id^="shopify-section-template"][id$="__text_with_middle_image_two_h8ycVe"][id] [class*="icons-title"][class][class]'
    + '{font-family:"Lora",Georgia,serif!important;font-weight:500!important;font-size:19px!important;line-height:1.3!important;color:#3B2A1E!important;margin-bottom:6px!important}'
    // FAQ / accordion titles: serif, sentence case, no caps
    + 'html body [id^="shopify-section-template"][id$="__image_with_accordions_qbQUj7"][id][id][id] :is(h4,h5,h6,summary,button,span,[class*="title"],[class*="heading"]):not(.iwt-top-head):not(.m-richtext__title):not(p span),html body [id^="shopify-section-template"][id$="__image_with_accordions_AywFmk"][id][id][id] :is(h4,h5,h6,summary,button,span,[class*="title"]):not(p span){font-family:"Lora",Georgia,serif!important;font-weight:500!important;text-transform:none!important;letter-spacing:0!important;font-size:17px!important}'
    // numbers section: serif numerals
    + '[id$="__pdp_image_with_number_MnQGB4"] :is(.m-number,.m-image-with-number__number,h2 span){font-family:"Lora",Georgia,serif!important;font-weight:400!important}';
  document.head.appendChild(st);
})();

// ---- Kanna: move "Real people, real results" UGC slider under the gallery card (gonza 2026-08-29)
(function () {
  if (!/\/products\/kanna/.test(location.pathname)) return;
  var tries = 0;
  function place() {
    var ugc = document.querySelector('[id$="__ugc_slider_W3U3EP"]');
    var host = document.querySelector(".bos-rot");
    if (!ugc || !host) { if (tries++ < 20) setTimeout(place, 400); return; }
    if (ugc.getAttribute("data-bos-moved")) return;
    var anchor = host.closest(".bos-rot-card, .m-product__rotator") || host;
    anchor.parentNode.insertBefore(ugc, anchor.nextSibling);
    ugc.style.position = "relative"; ugc.style.zIndex = "2"; ugc.style.width = "100%";
    ugc.setAttribute("data-bos-moved", "1");
    ugc.classList.add("bos-ugc-inline");
    // the theme's scroll-reveal observer was bound before the move: force everything visible + load lazy posters
    function reveal() {
      ugc.querySelectorAll(".m-scroll-trigger, [class*='animate--']").forEach(function (e) {
        e.classList.remove("m-scroll-trigger"); e.classList.add("animate--visible");
        e.style.setProperty("opacity", "1", "important"); e.style.setProperty("transform", "none", "important"); e.style.setProperty("visibility", "visible", "important");
      });
      ugc.querySelectorAll("img[data-src], img[data-srcset], video[data-src], source[data-src]").forEach(function (m) {
        if (m.dataset.src && !m.src) m.src = m.dataset.src; if (m.dataset.srcset && !m.srcset) m.srcset = m.dataset.srcset;
      });
      ugc.querySelectorAll("img[loading='lazy']").forEach(function (im) { im.loading = "eager"; });
      // theme's lazy background covers (m-bg-lazy) never fire after the move: paint them now
      ugc.querySelectorAll(".m-bg-lazy, [data-bg], [data-background]").forEach(function (c) {
        var u = c.getAttribute("data-bg") || c.getAttribute("data-background") || c.getAttribute("data-src");
        if (u && !/url\(/.test(c.style.backgroundImage || "")) c.style.backgroundImage = "url(" + u + ")";
        c.classList.remove("m-bg-lazy"); c.classList.add("m-bg-loaded");
      });
    }
    reveal(); setTimeout(reveal, 800); setTimeout(reveal, 2500);
    function tune() {
      var els = ugc.querySelectorAll(".swiper-container, .swiper");
      var ok = false;
      els.forEach(function (el) {
        var sw = el.swiper; if (!sw) return; ok = true;
        var spv = window.innerWidth < 768 ? 1.6 : 2.6;
        sw.params.slidesPerView = spv; sw.params.spaceBetween = 10; sw.params.centeredSlides = false;
        if (sw.params.breakpoints) Object.keys(sw.params.breakpoints).forEach(function (k) { sw.params.breakpoints[k].slidesPerView = spv; sw.params.breakpoints[k].spaceBetween = 10; });
        sw.currentBreakpoint = undefined; if (sw.setBreakpoint) sw.setBreakpoint(); sw.update();
        // continuous autoscroll: native autoplay, one slide at a time, no page grouping
        sw.params.speed = 900; sw.params.slidesPerGroup = 1;
        sw.params.autoplay = { delay: 1500, disableOnInteraction: false, pauseOnMouseEnter: true };
        if (sw.autoplay) { try { sw.autoplay.stop(); sw.autoplay.start(); } catch (e) {} }
        if (sw.pagination && sw.pagination.el) sw.pagination.el.style.display = "none";
      });
      if (!ok && tries++ < 30) setTimeout(tune, 500);
    }
    tune(); window.addEventListener("resize", tune);
    if (!document.getElementById("bos-ugc-inline-css")) {
      var st = document.createElement("style"); st.id = "bos-ugc-inline-css";
      st.textContent = ".bos-ugc-inline{margin:22px 0 0!important;padding:0!important;background:transparent!important}"
        + "html body [id^='shopify-section-template'][id][id][id].bos-ugc-inline :is(h2,.m-section__heading,.m-section-header__heading){font-size:clamp(22px,1.6vw,28px)!important;margin-bottom:4px!important}"
        + ".bos-ugc-inline .m-section-header{margin-bottom:12px!important}"
        + ".bos-ugc-inline .container,.bos-ugc-inline .container-fluid,.bos-ugc-inline .m-section__inner{padding-left:0!important;padding-right:0!important;max-width:none!important}"
        + ".bos-ugc-inline .swiper-pagination{display:none!important}"
        + ".bos-ugc-inline .m-video__cover{background-size:cover;background-position:center}"
        + ".bos-ugc-inline .swiper-slide,.bos-ugc-inline .m-scroll-trigger,.bos-ugc-inline [class*='animate--']{opacity:1!important;transform:none!important;visibility:visible!important}";
      document.head.appendChild(st);
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", place); else place();
})();

// ---- PDP typography sweep (gonza 2026-08-13): one serif (Lora), one sans (Inter).
// Kills leftover monospace body copy (B612 Mono / Menlo) and stray serifs
// (Georgia / Fraunces) wherever they render, without chasing theme selectors.
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var MONO = /^(B612 Mono|Menlo|ui-monospace|SF Mono|SFMono|Consolas|Courier|monospace)$/i;
  var SERIF = /^(Georgia|Fraunces|Times|Times New Roman)$/i;
  function ownText(el) {
    for (var c = 0; c < el.childNodes.length; c++) {
      var n = el.childNodes[c];
      if (n.nodeType === 3 && n.textContent.trim().length > 1) return true;
    }
    return false;
  }
  function sweep() {
    var els = document.querySelectorAll('[id^="shopify-section-template"] *');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!ownText(el)) continue;
      var first = (getComputedStyle(el).fontFamily || "").split(",")[0].replace(/["']/g, "").trim();
      if (MONO.test(first)) {
        var sec = el.closest('[id^="shopify-section-template"]');
        var serifBody = sec && /(custom_liquid_zHJA6K|pdp_image_with_text_tGCkji|pdp_image_with_text_xkE9xh|pdp_image_with_text_BWnRpK)$/.test(sec.id);
        el.style.setProperty("font-family", serifBody ? "'Lora',Georgia,serif" : "'Inter','Jost',sans-serif", "important");
        el.style.setProperty("letter-spacing", "normal", "important");
      } else if (SERIF.test(first)) {
        el.style.setProperty("font-family", "'Lora',Georgia,serif", "important");
      }
    }
  }
  function run() { sweep(); setTimeout(sweep, 1600); setTimeout(sweep, 4200); setTimeout(sweep, 8000); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
})();
